<template>
  <HomepageFeatureSection
    title="Automate routine tasks"
    body="Tell Era AI to schedule automatic money transfers, daily news updates, portfolio rebalances, and more."
    color="var(--colorSwissGreen300)"
  >
    <div class="HomepageRoutinesFeatureSection__routineList">
      <RoutineCard
        v-for="routine in routines"
        :key="routine.RoutineId"
        :modelValue="routine"
      />
    </div>
  </HomepageFeatureSection>
</template>

<script lang="ts" setup>
import HomepageFeatureSection from "@cosine/components/homepage/HomepageFeatureSection.vue";
import RoutineCard from "@cosine/components/RoutineCard.vue";
import { createRoutine } from "@cosine/tests/factories/RoutineFactory";
import { computed } from "vue";

const routines = computed(() => {
  return [
    createRoutine({
      Description: "Personalized inflation update",
      CronExpression: "0 17 * * 5",
    }),
    createRoutine({
      Description: "Monthly portfolio rebalance",
      CronExpression: "0 0 1 * *",
    }),
    createRoutine({
      Description: "Round-up transactions into savings",
      CronExpression: "0 9 * * 1",
    }),
  ];
});
</script>

<style lang="scss" scoped>
.HomepageRoutinesFeatureSection__routineList {
  align-content: center;
  padding: 0;
}
</style>
